import {
  get,
} from '@/utils/request';

const url = 'card-ticket-del-records';

export function index(data) {
  return get({
    url,
    data,
  });
}


export function show(id) {
  return get({
    url: `${url}/${id}`,
  });
}
